import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const World: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path fillRule="evenodd" d="M12.73 2a.82.82 0 0 0-.35 0h-.76a.83.83 0 0 0-.35 0 10 10 0 0 0 0 19.94.82.82 0 0 0 .35 0h.76a.83.83 0 0 0 .35 0 10 10 0 0 0 0-19.94ZM9.62 4.36A8 8 0 0 0 5.07 8h3.3a18.86 18.86 0 0 1 1.25-3.64ZM10.43 8A16.35 16.35 0 0 1 12 4.11 16.19 16.19 0 0 1 13.57 8ZM8 10H4.25a8.2 8.2 0 0 0 0 4H8a19.1 19.1 0 0 1 0-4Zm2 4a15.75 15.75 0 0 1 0-4h4a15.75 15.75 0 0 1 0 4Zm-1.63 2h-3.3a8 8 0 0 0 4.55 3.64A18.86 18.86 0 0 1 8.37 16ZM12 19.89A16.19 16.19 0 0 1 10.43 16h3.14A16.19 16.19 0 0 1 12 19.89Zm2.38-.25A8 8 0 0 0 18.93 16h-3.3a18.86 18.86 0 0 1-1.25 3.64ZM16 14h3.77a8 8 0 0 0 0-4H16a17.83 17.83 0 0 1 0 4Zm-.34-6h3.3a8 8 0 0 0-4.55-3.64A18.86 18.86 0 0 1 15.63 8Z" />
  </Icon>
);

export default World;
